<div class="subscribe-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="subscribe-content">
                    <h2>Abonniere unseren Newsletter</h2>
                    <p>Bleibe immer auf dem Laufenden über aktuelle Angebote, Fahrkurse und wichtige Informationen zu unserer Fahrschule. Melde dich noch heute an!</p>
                </div>
            </div>

            <!-- Formular -->
            <div class="col-lg-6 col-md-6">
                <form [formGroup]="newsletterForm" (ngSubmit)="onSubmit()" *ngIf="!subscriptionSuccess" class="newsletter-form">
                    <input
                        type="email"
                        class="input-newsletter"
                        formControlName="email"
                        placeholder="Deine E-Mail-Adresse"
                        required
                        autocomplete="off">
                    <button type="submit" [disabled]="newsletterForm.invalid">
                        Jetzt abonnieren
                    </button>
                </form>

                <!-- Message de succès -->
                <div *ngIf="subscriptionSuccess" class="alert alert-success" role="alert">
                    <h4 class="alert-heading">Vielen Dank für Ihre Anmeldung!</h4>
                    <p>Sie haben sich erfolgreich für unseren Newsletter angemeldet. Bleiben Sie auf dem Laufenden mit unseren neuesten Nachrichten und Angeboten.</p>
                    <hr>
                    <p class="mb-0">Willkommen in unserer Community!</p>
                </div>
            </div>
        </div>
    </div>
</div>
